import { createContext, useContext, useMemo, useState, type ReactNode } from "react";

interface DrawerContextProps {
    isOpen: boolean;
    content: ReactNode | null;
    openDrawer: (content: ReactNode) => void;
    closeDrawer: () => void;
}

const DrawerContext = createContext<DrawerContextProps | undefined>(undefined);

export const DrawerProvider = ({ children }: React.PropsWithChildren<{}>) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [content, setContent] = useState<ReactNode | null>(null);

    const openDrawer = (content: ReactNode) => {
        setContent(content);
        setIsOpen(true);
    };

    const closeDrawer = () => {
        setContent(null);
        setIsOpen(false);
    }

    const value = useMemo(() => ({ isOpen, content, openDrawer, closeDrawer }), [isOpen, content]);
    return <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>;
};

export const useDrawer = () => {
    const context = useContext(DrawerContext);
    if (!context) throw new Error("useDrawer must be used within DrawerProvider");
    return context;
};
